import React, { useContext } from 'react';
import { useFormik } from 'formik';
import { Box } from '@mui/material';
import validationSchema from '../helpers/validationSchema';
import { UIContext } from '../../../../../context/UIContext';
import { Product } from '../../helpers/types';
import { SidekickTablesContext } from '../../helpers/SidekickTablesContext';
import ImportedProductsForm from './ImportedProductsForm';

const EditImportedProductCard = ({
  currentObject,
  resetObject,
}: {
  currentObject: Product;
  resetObject: () => void;
}) => {
  const { updateObject } = useContext(SidekickTablesContext);
  const { isMobile } = useContext(UIContext);

  const formik = useFormik({
    initialValues: {
      ...currentObject,
      categoryId: currentObject.categoryId?.toString() || null,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, actions) => {
      const valuesToCast = {
        name: values.name,
        description: values.description,
        salePriceIncTax: values.salePriceIncTax,
      };

      const requestValues: Product = {
        ...values,
        ...validationSchema.cast(valuesToCast),
        categoryId: values.categoryId ? +values.categoryId : null,
      };

      actions.setSubmitting(false);
      updateObject(requestValues);
    },
  });

  return (
    <Box
      padding={2}
      paddingTop={3}
      marginTop={7}
      sx={{ mb: '65px', overflow: isMobile ? 'hidden' : 'auto' }}
    >
      <ImportedProductsForm
        formik={formik}
        cancelAction={() => {
          resetObject();
        }}
        objectId={currentObject.id.toString()}
      />
    </Box>
  );
};

export default EditImportedProductCard;
